<template>
  <Teleport to="body">
    <ModalLoginModal
      v-if="modalStore.modals.login.visible"
      :show="modalStore.modals.login.visible"
    />
    <ModalNewModal
      v-if="modalStore.modals.new.visible"
      :show="modalStore.modals.new.visible"
      @modal-toggle="modalStore.toggleModal(ModalType.New)"
    />
    <ModalLoadModal
      v-if="modalStore.modals.load.visible"
      :show="modalStore.modals.load.visible"
      @modal-toggle="modalStore.toggleModal(ModalType.Load)"
    />
    <ModalSaveModal
      :show="modalStore.modals.saveAs.visible"
      @modal-toggle="modalStore.toggleModal(ModalType.SaveAs)"
    />
    <ModalMyDesignsModal
      v-if="modalStore.modals.myDesigns.visible"
      :show="modalStore.modals.myDesigns.visible"
      @modal-toggle="modalStore.toggleModal(ModalType.MyDesigns)"
    />
    <ModalGridSizeModal
      v-if="modalStore.modals.gridSize.visible"
      :show="modalStore.modals.gridSize.visible"
      @modal-toggle="modalStore.toggleModal(ModalType.GridSize)"
    />
    <ModalMyTilesModal
      v-if="modalStore.modals.myTiles.visible"
      :show="modalStore.modals.myTiles.visible"
    />
    <ModalShareModal
      v-if="modalStore.modals.share.visible"
      :show="modalStore.modals.share.visible"
    />
    <ModalFileModal
      v-if="modalStore.modals.file.visible"
      :show="modalStore.modals.file.visible"
    />
    <ModalColorRemapModal
      v-if="modalStore.modals.colorRemap?.visible"
      :show="modalStore.modals.colorRemap?.visible"
      @modal-toggle="modalStore.toggleModal(ModalType.ColorRemap)"
    />
  </Teleport>
</template>

<script setup>
import { ModalType } from "~/stores/modal";
const modalStore = useModalStore();
</script>
